import React, { useState } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import StatsCard from './statsCard';
import { Category, Schedule, WorkOutline, Equalizer } from '@material-ui/icons';
import { useEffect } from 'react';
import { getScoresStats } from 'controllers/dashboard/getScoresStats';

const useStyles = makeStyles(() => ({
  cardsContainer: {
    background: '#fff',
    borderRadius: 2,
    padding: '18px 0 0',
    height: 'calc(100% - 25px)',
  },
}));

const StatsCards = ({ jobId }) => {
  const classes = useStyles();
  const [stats, setStats] = useState({
    expMatchScore: 70,
    overallScore: 70,
    skillMatchScore: 70,
    titleMatchScore: 70,
  });
  const [score, setScore] = useState({
    expMatchScore: 0,
    overallScore: 0,
    skillMatchScore: 0,
    titleMatchScore: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      const response = await getScoresStats({
        ...stats,
        jobId,
      });

      setScore(response);
    };

    fetchData();
  }, [
    stats,
    stats.expMatchScore,
    stats.overallScore,
    stats.skillMatchScore,
    stats.titleMatchScore,
    jobId,
  ]);

  const onChangeStat = (name, value) => {
    setStats((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      <Grid container classes={{ root: classes.cardsContainer }}>
        <Grid item xs={6}>
          <StatsCard
            Icon={Category}
            title={score.skillMatchScore}
            subtitle={'Skills Matching'}
            name={'skillMatchScore'}
            onChangeStat={onChangeStat}
          />
        </Grid>
        <Grid item xs={6}>
          <StatsCard
            Icon={Schedule}
            title={score.expMatchScore}
            subtitle={'Exp Matching'}
            name={'expMatchScore'}
            onChangeStat={onChangeStat}
          />
        </Grid>
        <Grid item xs={6}>
          <StatsCard
            Icon={WorkOutline}
            title={score.titleMatchScore}
            subtitle={'Job Title Matching'}
            name={'titleMatchScore'}
            onChangeStat={onChangeStat}
          />
        </Grid>
        <Grid item xs={6}>
          <StatsCard
            Icon={Equalizer}
            title={score.overallScore}
            subtitle={'Overall'}
            name={'overallScore'}
            onChangeStat={onChangeStat}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default StatsCards;
